function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { GithubPicker } from 'react-color';
import './ColorSelector.css';

function useComponentVisible(initialIsVisible) {
  var _useState = useState(initialIsVisible),
      _useState2 = _slicedToArray(_useState, 2),
      isComponentVisible = _useState2[0],
      setIsComponentVisible = _useState2[1];

  var ref = useRef(null);

  var handleHideDropdown = function handleHideDropdown(event) {
    setIsComponentVisible(false);
  };

  var handleClickOutside = function handleClickOutside(event) {
    if (ref.current && !ref.current.contains(event.target)) {
      setIsComponentVisible(false);
    }
  };

  useEffect(function () {
    document.addEventListener("keydown", handleHideDropdown, true);
    document.addEventListener("click", handleClickOutside, true);
    return function () {
      document.removeEventListener("keydown", handleHideDropdown, true);
      document.removeEventListener("click", handleClickOutside, true);
    };
  });
  return {
    ref: ref,
    isComponentVisible: isComponentVisible,
    setIsComponentVisible: setIsComponentVisible
  };
}

var ColorSelector = function ColorSelector(_ref) {
  var colorSetter = _ref.colorSetter,
      backgroundColor = _ref.backgroundColor,
      id = _ref.id;

  var _useComponentVisible = useComponentVisible(false),
      ref = _useComponentVisible.ref,
      isComponentVisible = _useComponentVisible.isComponentVisible,
      setIsComponentVisible = _useComponentVisible.setIsComponentVisible;

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      edit = _useState4[0],
      setEdit = _useState4[1];

  var handleChange = function handleChange(color) {
    setEdit(false);
    colorSetter(id, color);
  };

  var availableColors = [// "#f44336", 
  //"#e91e63", 
  "#9c27b0", "#673ab7", "#3f51b5", "#2196f3", "#03a9f4", "#00bcd4", //"#009688", 
  // "#4caf50", 
  // "#8bc34a", 
  "#cddc39", "#ffeb3b", "#ffc107", "#ff9800", // "#ff5722", 
  "#795548", "#607d8b"];
  return /*#__PURE__*/React.createElement("div", {
    className: "color-selector",
    ref: ref
  }, isComponentVisible && /*#__PURE__*/React.createElement("span", {
    className: "color-selector__icon",
    style: {
      backgroundColor: backgroundColor
    },
    onClick: function onClick() {
      return setIsComponentVisible(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "color-selector__swatch"
  }, /*#__PURE__*/React.createElement(GithubPicker, {
    onChangeComplete: handleChange,
    colors: availableColors
  }))), !isComponentVisible && /*#__PURE__*/React.createElement("span", {
    className: "color-selector__icon",
    style: {
      backgroundColor: backgroundColor
    },
    onClick: function onClick() {
      return setIsComponentVisible(true);
    }
  }));
};

export default ColorSelector;